module.exports = __webpack_public_path__ + "img/om_qr_pdd.3df33168.png";